(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const clamp = (v, min, max) => Math.max(min, Math.min(max, v));

  const toSpeed = (value, fallback) => {
    if (value == null) return fallback;

    const s = String(value).trim();

    if (s.includes('.')) {
      const f = Number.parseFloat(s);
      if (Number.isFinite(f)) return f;
    }

    const n = Number.parseInt(s, 10);
    if (Number.isFinite(n)) return n / 100;

    return fallback;
  };

  const initSection = (section) => {
    if (!section || reducedMotion) return;

    const stage = section.querySelector('[data-parallax-stage]');
    if (!stage) return;

    const layers = {
      back: section.querySelector('[data-parallax-layer="back"]'),
      mid: section.querySelector('[data-parallax-layer="mid"]'),
      front: section.querySelector('[data-parallax-layer="front"]')
    };

    if (!layers.back && !layers.mid && !layers.front) return;

    const speedBack = toSpeed(section.dataset.parallaxSpeedBack, 0.2);
    const speedMid = toSpeed(section.dataset.parallaxSpeedMid, 0.35);
    const speedFront = toSpeed(section.dataset.parallaxSpeedFront, 0.55);
    const mobileScale = toSpeed(section.dataset.parallaxMobileScale, 0.6);

    let active = false;
    let raf = null;

    const mqlMobile = window.matchMedia('(max-width: 989px)');
    const isMobile = () => mqlMobile.matches;

    const update = () => {
      raf = null;
      if (!active) return;

      const rect = section.getBoundingClientRect();
      const stageRect = stage.getBoundingClientRect();
      const vh = window.innerHeight || document.documentElement.clientHeight;

      if (rect.top >= vh) {
        if (layers.back) layers.back.style.setProperty('--parallax-parallax', `0px`);
        if (layers.mid) layers.mid.style.setProperty('--parallax-parallax', `0px`);
        if (layers.front) layers.front.style.setProperty('--parallax-parallax', `0px`);
        return;
      }
      if (rect.bottom <= 0) return;

      const start = vh;
      const end = vh - rect.height;
      const t = (rect.top - end) / (start - end);
      const progress = 1 - clamp(t, 0, 1);
      const amp = clamp(stageRect.height * 0.45, 120, Math.max(420, stageRect.height * 0.9));

      const m = isMobile() ? mobileScale : 1;
      const offset = (progress - 0.5) * amp * 2 * m;


      if (layers.back) {
        layers.back.style.setProperty('--parallax-parallax', `${(offset * speedBack).toFixed(2)}px`);
      }

      if (layers.mid) {
        layers.mid.style.setProperty('--parallax-parallax', `${(offset * speedMid).toFixed(2)}px`);
      }

      if (layers.front) {
        layers.front.style.setProperty('--parallax-parallax', `${(offset * speedFront).toFixed(2)}px`);
      }
    };

    const requestUpdate = () => {
      if (raf) return;
      raf = requestAnimationFrame(update);
    };

    const observer = new IntersectionObserver(
      (entries) => {
        active = entries.some((e) => e.isIntersecting);
        if (active) requestUpdate();
      },
      { threshold: 0 }
    );

    observer.observe(section);

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);

    requestUpdate();

    section._parallaxCleanup = () => {
      observer.disconnect();
      window.removeEventListener('scroll', requestUpdate);
      window.removeEventListener('resize', requestUpdate);
      if (raf) cancelAnimationFrame(raf);
    };
  };

  const initAll = () => {
    document.querySelectorAll('[data-parallax-section]').forEach(initSection);
  };

  document.addEventListener('shopify:section:load', (e) => {
    const section = document.querySelector(
      `#shopify-section-${e.detail.sectionId} [data-parallax-section]`
    );
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', (e) => {
    const section = document.querySelector(
      `#shopify-section-${e.detail.sectionId} [data-parallax-section]`
    );
    if (section && section._parallaxCleanup) section._parallaxCleanup();
  });

  initAll();
})();
